import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import ItemMasterServices from '../../../services/axioServices/apiServices/ItemMasterServices';
import CommonServices from '../../../services/axioServices/apiServices/CommonServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Navigate } from 'react-router-dom';
import FinishProductTestEntryInputs from './FinishProductTestEntryInputs';
import QCServices from '../../../services/axioServices/apiServices/QCServices';
import { decryptAES } from '../../../utils/Encryption';
import RawMaterialTestEntryInputs from './RawMaterialTestEntryInputs';
import { isValidForm } from '../../../utils/validation/CommonValidator';

export default class FinishProductTestEntryDetails extends Component {
    constructor(props) {
        super(props);
        this.qcServices = new QCServices();
        this.itemMasterServices = new ItemMasterServices();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.state = {
            route: null,
            analystList: [],
            labList: [],
            inchargeList: [],
            testReportFGId: null,
            sampleEntryFGId: null,
            reportObject: {
                refNo: "",
                reportNo: "",
                reportDate: "",
                materialName: "",
                batchNo: "",
                partyName: "",
                purchaseQty: "",
                mfgBy: "",
                analyst: "",
                labId: "",
                labIncharge: "",
                materialId: "",
                sampleQty: "",
                analysisDate: ""
            },
            testObject: {
                testName: "",
                result: "",
                limit: "",
                isEditing: false,
                monogramId: "",
                index: null
            },
            tableData: [],
            columns: [
                { field: 'testName', header: 'Test Name' },
                { field: 'result', header: 'Result' },
                { field: 'limit', header: 'Limit' },
                { field: 'action', header: 'Action', body: this.actionTemplate, sortable: false }
            ],
            validationRules: {
                reportNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "report no"
                        ),
                    },
                ],
                reportDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "report date"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let sampleEntryFGId = decryptAES(id)
            if (sampleEntryFGId) {
                if (sampleEntryFGId != null) {
                    this.setState({ sampleEntryFGId: sampleEntryFGId }, () => {
                        this.getFinishGoodsSampleEntryDetailsById(this.state.sampleEntryFGId)
                    });
                }
            }
        }
        let FGTestId = params.get("FGTestId")
        if (FGTestId) {
            let testReportFGId = decryptAES(FGTestId)
            if (testReportFGId) {
                if (testReportFGId != null) {
                    this.setState({ testReportFGId: testReportFGId }, () => {
                        this.getFinishGoodsTestEntryDetailsById(this.state.testReportFGId)
                    });
                }
            }
        }
    }

    getFinishGoodsSampleEntryDetailsById = (sampleEntryFGId) => {
        this.qcServices.getFinishGoodsSampleEntryDetailsById(sampleEntryFGId).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let details = this.state.reportObject
                details.refNo = res.refNo
                details.batchNo = res.batchNo
                details.mfgBy = res.mfgBy
                details.labName = res.labName
                details.productionId = res.productionId
                details.purchaseQty = res.batchSize
                details.partyName = res.partyName
                details.materialName = res.productName
                details.materialId = res.productId
                details.sampleQty = res.sampleQty
                this.setState({ reportObject: details }, () => {
                    this.getQCMonogramByProductId(this.state.reportObject.materialId)
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getFinishGoodsTestEntryDetailsById = (testReportFGId) => {
        this.qcServices.getFinishGoodsTestEntryDetailsById(testReportFGId).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let reportObject = this.state.reportObject
                reportObject.analyst = res.analyst
                reportObject.batchNo = res.batchNo
                reportObject.productionId = res.productionId
                reportObject.labIncharge = res.labIncharge
                reportObject.labName = res.labName
                reportObject.materialName = res.materialName
                reportObject.mfgBy = res.mfgBy
                reportObject.partyName = res.partyName
                reportObject.purchaseQty = res.batchSize
                reportObject.refNo = res.refNo
                reportObject.reportDate = res.reportDate
                reportObject.reportNo = res.reportNo
                reportObject.sampleQty = res.sampleQty
                reportObject.analysisDate = res.analysisDate
                this.setState({ reportObject: reportObject, tableData: res.tableData, sampleEntryFGId: res.sampleEntryFGId })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getQCMonogramByProductId = (id) => {
        this.itemMasterServices.getQCMonogramByProductId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                this.setState({ tableData: res })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "report") {
            let details = this.state.reportObject;
            details[name] = value.toUpperCase();
            this.setState({ reportObject: details });
        } else {
            let details = this.state.testObject;
            details[name] = value.toUpperCase();
            this.setState({ testObject: details });
        }
    };

    setFilterParametersForItemName = (selected, name) => {
        if (selected.value) {
            let reportObject = this.state.reportObject;
            reportObject[name] = selected.value;
            this.setState({ reportObject: reportObject });
        }

    }

    actionTemplate = (rowData, options) => {
        return (
            <div className="flex gap-2">
                <button
                    className="search-btn w-[28px] h-[28px] bg-blue text-white rounded"
                    onClick={() => this.handleEdit(rowData, options)}
                >
                    <FontAwesomeIcon icon={faPen} className='w-[14px] h-[14px]' />
                </button>
            </div>
        );
    };


    handleEdit = (rowData, options) => {
        let details = this.state.testObject
        details.testName = rowData.testName
        details.result = rowData.result
        details.limit = rowData.limit
        details.isEditing = true
        details.monogramId = rowData.monogramId
        details.index = options.rowIndex
        this.setState({ testObject: details })
    }

    backPage = () => {
        this.setState({ route: '/FinishProductTestReportEntry' });
    };

    clearTestObject = () => {
        let testObject = this.state.testObject
        testObject.testName = ''
        testObject.result = ''
        testObject.limit = ''
        testObject.isEditing = false
        testObject.monogramId = ''
        testObject.index = null
        this.setState({ testObject: testObject })
    }

    updateTestResult = () => {
        // let testObject = this.state.testObject
        // let tableData = this.state.tableData
        // const index = tableData.findIndex(item => item.monogramId === testObject.monogramId);

        // if (index !== -1) {
        //     tableData[index] = { ...tableData[index], ...testObject };
        //     this.setState({ tableData }, () => {
        //         this.clearTestObject()
        //     });
        // }

        let arr = [...this.state.tableData]
        let testObject = { ...this.state.testObject }
        arr[testObject.index] = testObject;
        this.setState({
            tableData: arr,
        }, () => {
            this.clearTestObject()
        });
    }

    isAllFieldsValidate = () => {
        const newValidState = isValidForm(
            this.state.reportObject,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid
    }

    addEditFinishGoodsTestReport = () => {
        if (this.state.tableData.length === 0) {
            this.SwalServices.ErrorWithMonogram(
                ``,
                'Add Monogram',
                'Cancel',
                `Please add monogram for this product.`
            ).then((response) => {
                if (response) {
                    this.setState({ route: '/QCMonogramFinishProduct' })
                }
            });
        } else {
            let isValid = this.isAllFieldsValidate()
            if (isValid) {
                let reportObject = this.state.reportObject
                let request = {
                    reportNo: reportObject.reportNo,
                    reportDate: reportObject.reportDate,
                    analyst: reportObject.analyst,
                    labIncharge: reportObject.labIncharge,
                    sampleEntryFGId: this.state.sampleEntryFGId,
                    analysisDate: reportObject.analysisDate,
                    productionId: reportObject.productionId,
                    tableData: this.state.tableData
                }
                if (this.state.testReportFGId) {
                    request.testReportFGId = this.state.testReportFGId
                }
                this.qcServices.addEditFinishGoodsTestReport(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData !== null) {
                        if (this.state.testReportFGId) {
                            this.backPage()
                        } else {
                            this.backPage()
                        }
                        this.SwalServices.Success(response.Message)
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                })
            }
        }
    }

    generateTestingEntryFGReport = () => {
        this.setState({ isLoading: 'print' }, () => {
            let request = [this.state.testReportFGId]
            this.qcServices.generateTestingEntryFGReport(request).then((response) => {
                if (response && response.status === 200) {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    // let blob = new Blob([response.data])
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.click();
                    this.setState({ isLoading: "" })
                }
                this.setState({ isLoading: false });
            })
        })
    }

    render() {
        if (this.state.route !== null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='raw-sample-fields'>
                <h1 className='text-[18px] font-semibold text-blue pb-[5px] mb-[5px]'>Finish Product Test Entry</h1>
                <RawMaterialTestEntryInputs
                    reportObject={this.state.reportObject}
                    testObject={this.state.testObject}
                    handleChange={this.handleChange}
                    setFilterParametersForItemName={this.setFilterParametersForItemName}
                    analystList={this.state.analystList}
                    inchargeList={this.state.inchargeList}
                    labList={this.state.labList}
                    tableData={this.state.tableData}
                    columns={this.state.columns}
                    clearTestObject={this.clearTestObject}
                    updateTestResult={this.updateTestResult}
                    validState={this.state.validState}
                    testEntryType='FinishProducts'
                />
                <div className='btn-grp flex items-center gap-5 mt-2.5'>
                    <button
                        onClick={this.addEditFinishGoodsTestReport}
                        className='search-btn'>
                        Save
                    </button>
                    <button className='cancel-btn'
                        onClick={this.backPage}
                    >
                        Cancel
                    </button>
                    {this.state.testReportFGId !== null && this.state.testReportFGId !== undefined && this.state.testReportFGId !== "" ?
                        <button className='print-btn' onClick={this.generateTestingEntryFGReport}>Print</button>
                        : null}
                </div>
            </div>
        )
    }
}
